import { computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useCommonStore } from '@/stores/common.stores'
import { headerTitleList } from '@/constants/common/header.const'
import { getI18nTranslate } from '@/utils/i18nUtils'

/** header 相關邏輯 */
export const useHeader = () => {
  const router = useRouter()
  const commonStore = useCommonStore()

  // 是否顯示返回按鈕
  const showGoBack = computed<boolean>(() => {
    if (router.currentRoute.value.name == 'Home') return false

    return true
  })

  const isShowFlashSale = computed(() => {
    const name = router.currentRoute.value.name
    return name &&
      ['FeeDetails', 'PaymentOptions', 'PaymentRecords', 'PaymentConfirmation'].includes(
        name as string
      )
      ? false
      : true
  })

  // 返回上一頁
  const goPrevPage = () => {
    router.go(-1)
  }

  // 進到資費方案頁面
  const goFeeDetailsPage = () => {
    router.push({ name: 'FeeDetails' })
  }

  /** 處理header title
   *  尋找 headerTitleList 中是否有與當前頁面相同的 header title
   */
  const headerTitleHandler = (title: string = '') => {
    const currentPage = router.currentRoute.value.name
    const item = headerTitleList.find((item) => item.name == currentPage)
    if (!item) return title
    if (!item['header-title-key']) return ''
    return getI18nTranslate(item['header-title-key'])
  }

  const updateHeaderTitle = (customTitle?: string) => {
    // 需求: header title 有可能會在不同頁面中重新定義，所以使用 commonStore
    commonStore.headerTitle = customTitle || headerTitleHandler()
  }

  // 每次路由改變後更新 headerTitle
  router.afterEach(() => {
    updateHeaderTitle()
  })

  onMounted(() => {
    updateHeaderTitle()
  })

  return {
    showGoBack,
    isShowFlashSale,
    goPrevPage,
    goFeeDetailsPage,
    updateHeaderTitle
  }
}
